import { Translations } from './Translations'
import { useT } from './contexts/LocalizationContext'
import { LangSaveType, LocalizationModel, localizationSettings } from './utils/localization'

localizationSettings.default = 'cs'
localizationSettings.langs = ['cs', 'en']
localizationSettings.type = LangSaveType.url

export const localizationModel: LocalizationModel = {
  cs: require('./translations/cs.json'),
  en: require('./translations/en.json')
}

export const useAppT = () => useT<Translations>()
